import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Default configuration structure
var currentConfiguration = {
  styles: {
    namespace: null
  }
};

var updateConfiguration = function updateConfiguration(newValues) {
  currentConfiguration = _objectSpread(_objectSpread({}, currentConfiguration), newValues);
}; // Add a way to set the configuration without a knowledge of this package.
// We need this, because sometimes we don't have access to the actual wel
// context.


if (global.emcmUiConfig) {
  updateConfiguration(global.emcmUiConfig);
}

export default {
  get current() {
    return currentConfiguration;
  }

};
export { updateConfiguration };